module.exports = __webpack_public_path__ + "img/digitalMarketing.d1e1ca6e.jpg";